function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import utils from '@/js/utils';
import BiUserAccessService from '@/apps/data-platform/services/visualization/bi_user_access_service';
import { mapState } from 'vuex';
import UserAccessObjects from '@/modules/tasks/powerbi/components/UserAccessObjects.vue';
import UserAccessNew from '@/modules/tasks/powerbi/components/UserAccessNew.vue';
import UserAccessLogs from '@/modules/tasks/powerbi/components/UserAccessLogs.vue';
import UserAccessDetails from '@/modules/tasks/powerbi/components/UserAccessDetails.vue';
import { textsDefaul } from '@/js/constants';
import tasks from '@/js/tasks';
export default {
  name: 'VisualizationUserAccessBi',
  components: {
    UserAccessObjects: UserAccessObjects,
    UserAccessNew: UserAccessNew,
    UserAccessLogs: UserAccessLogs,
    UserAccessDetails: UserAccessDetails
  },
  data: function data() {
    return {
      items: [],
      messageLoading: textsDefaul.LOADING,
      isBusy: false,
      modalName: 'Assign User',
      modalUserAccessObject: 'modalUserAccessObject',
      modalUserAccessNew: 'modalUserAccessNew',
      modalUserAccessLogs: 'modalUserAccessLogs',
      record: Object,
      expanded: [],
      pagination: {
        current: 1,
        limit: 10,
        offset: 0,
        total: 0
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['isPowerBIMultipleAccess'])), {}, {
    fields: function fields() {
      return [{
        key: 'email',
        label: this.traductor('tablas.user_pbi'),
        class: 'w-30'
      }, {
        key: 'name',
        label: this.traductor('tablas.name'),
        class: 'w-40'
      },
      // { key: 'groups', label: 'Groups', class: 'w-50' },
      {
        key: 'actions',
        label: this.traductor('tablas.actions'),
        class: 'w-30'
      }];
    },
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.traductor('my_tasks.subtitle_visualization_access'),
        disabled: true
      }];
    },
    headers: function headers() {
      return [{
        value: 'email',
        text: this.traductor('my_tasks.tablas_tasks.user_pbi'),
        class: 'w-30'
      }, {
        value: 'name',
        text: this.traductor('my_tasks.tablas_tasks.name'),
        class: 'w-40',
        align: "center"
      },
      // { key: 'groups', label: 'Groups', class: 'w-50' },
      {
        value: 'actions',
        text: this.traductor('my_tasks.tablas_tasks.actions'),
        class: 'w-30',
        align: "center"
      }];
    },
    texts: function texts() {
      return {
        email: this.traductor('my_tasks.email_details'),
        new_email: this.traductor('my_tasks.new_email'),
        permission: this.traductor('my_tasks.permission'),
        logs: this.traductor('my_tasks.audit_logs'),
        download: this.traductor('botones.boton_descargar_csv')
      };
    }
  }),
  created: function created() {
    this.getItems();
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    clickedRow: function clickedRow(value) {
      console.log(value);
      if (this.expanded.length && this.expanded[0].id == value.id) {
        this.expanded = [];
      } else {
        this.expanded = [];
        this.expanded.push(value);
      }
    },
    getItems: function getItems() {
      var _this = this;
      var params = {
        domain: window.userInfo.domain
      };
      this.isBusy = true;
      BiUserAccessService.getAll(params).then(function (response) {
        _this.items = response.data.result;
      }).finally(function () {
        _this.isBusy = false;
      });
    },
    showModalUserAccessObject: function showModalUserAccessObject(data) {
      this.record = utils.cloneJSON(data.item);
      this.$refs[this.modalUserAccessObject].onOpen();
      //this.$root.$emit('bv::show::modal', this.modalUserAccessObject, '#btnShow')
    },
    showModalUserAccessNew: function showModalUserAccessNew(data) {
      var _this2 = this;
      this.record = utils.cloneJSON(data.item);
      if (this.isPowerBIMultipleAccess) {
        this.$refs[this.modalUserAccessNew].onOpen();
      } else {
        var params = {
          record: {
            document_id: this.record.user_id
          }
        };
        BiUserAccessService.getUsersInca(params).then(function (response) {
          var items = response.data.result;
          if (items.length > 0) {
            tasks.toast.error('Solo puede asignar un usuario.');
          } else {
            _this2.$refs[_this2.modalUserAccessNew].onOpen();
          }
        });
      }
      //this.$root.$emit('bv::show::modal', this.modalUserAccessNew, '#btnShow')
    },
    showModalUserAccessLogs: function showModalUserAccessLogs(data) {
      this.record = utils.cloneJSON(data.item);
      this.$refs[this.modalUserAccessLogs].onOpen();
      //this.$root.$emit('bv::show::modal', this.modalUserAccessLogs, '#btnShow')
    },
    downloadMassive: function downloadMassive() {
      var _this3 = this;
      BiUserAccessService.downloadUserbiDP().then(function (response) {
        _this3.downloadAction({
          name: 'Visualization_User_Access'
        }, response.data);
      });
    },
    downloadData: function downloadData(data) {
      var _this4 = this;
      var params = {
        record: {
          document_id: data.user_id
        }
      };
      return BiUserAccessService.downloadUserbiDP(params).then(function (response) {
        _this4.downloadAction(data, response.data);
      });
    },
    downloadAction: function downloadAction() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Array;
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      var universalBOM = "\uFEFF";
      var url = 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + body);
      a.href = url;
      a.download = "".concat(item.email ? item.email : item.name ? item.name : 'reporte de accesos', ".csv");
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }
};